import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from './Portfolio';
import MinecraftPortfolio from './MinecraftPortfolio';

function App() {
  return (
    <Router>
      <Routes>
        <Route path = "/" element={<Portfolio />} />
        <Route path = "/minecraft" element={<MinecraftPortfolio />} />
      </Routes>
    </Router>
  );
}

export default App;